import { createSlice } from "@reduxjs/toolkit";
import {
  fechVKYCDataByPrimaryWorkflowId,
  fetchDashboardDetailConfiguration,
  fetchSubWorkflowInfoById,
  fetchWorkflowInfoById,
  linkCrnToWorkflow,
  postRequestedDocs,
  sendreminderAboutStatus,
  updateDataAndStatusById,
  welcomeLetter,
  dataMatchAggregate,
} from "api/dashboardDetail";
import { requestChangeForPaymentThroughId } from "api/payment";
import { createSupportingDocumentsConfig } from "api/supportingDocuments";
import { getUserNamesByIds } from "api/user";

const initialState = {
  requestedDocs: [],
  postRequestedDocsloading: false,
  error: null,
  success: null,
  workFlowInfo: {},
  workFlowInfoLoading: false,
  workFlowInfoError: null,
  userSubworkFlowInfo: {},
  fetchedWorkflow: false,
  currentSubWorkFlowId: null,
  userSubworkFlowInfoLoading: false,
  usersList: {},
  dashboardDetailData: {},
  successFullySentTouser: false,
  successFullySentRequestForSupportingDocumentsTouser: false,
  editUserDataRoutedSuccessFully: false,
  fetchingDashboardDetailConfiguration: false,
  dashboardDetailConfiguration: {},
  vkycResponseOfAllSubWorkFlows: [],
  vkyCResponseLoading: false,
  doesAnySubWorkflowHasVkyc: false,
  vkyCQueue: [],
  welcomeLetterHtmlContent: "",
  noDataFoundForTheGivenId: false,
  toastContainer: {},
  clientLoagoutUrl: "",
  activeNavTab: "",
  sentReminderAboutStatus: false,
  clientLogoutURL: "",
  sideBarStructure: {},
  actionSuccess: false,
  checkingForApprovalButtonConstraint: false,
  shouldShowActionButtonsForApproval: false,
  userNamesInfo : {}
};

export const requestedDocsReducer = createSlice({
  name: "requestedDocsReducer",
  initialState,
  reducers: {
    setRequestedDocs: (state, action) => {
      state.requestedDocs = action.payload;
    },
    setworkFlowInfo: (state, action) => {
      state.workFlowInfo = action.payload;
    },
    setuserSubworkFlowInfo: (state, action) => {
      state.userSubworkFlowInfo = action.payload;
    },
    setSubworkFlowInfo: (state, action) => {
      if (action.payload.key) {
        state.userSubworkFlowInfo.source_data = {
          ...state.userSubworkFlowInfo,
          [action.payload.key]: action.payload.value,
        };
      }
    },
    clearworkFlowInfo: (state, action) => {
      state.workFlowInfo = {};
    },
    clearuserSubworkFlowInfo: (state, action) => {
      state.userSubworkFlowInfo = {};
    },
    setCurrentSubworkFlowId: (state, action) => {
      state.currentSubWorkFlowId = action.payload;
    },
    ResetCurrentSubworkFlowId: (state, action) => {
      state.currentSubWorkFlowId = ''
    },
    setusersList: (state, action) => {
      state.usersList = action.payload;
    },
    clearusersList: (state, action) => {
      state.usersList = {};
    },
    setDashBoardDetailData: (state, action) => {
      state.dashboardDetailData = action.payload;
    },
    ResetDashBoardDetailData: (state, action) => {
      state.dashboardDetailData = {};
    },
    setSuccessFullySentTouser: (state, action) => {
      state.successFullySentTouser = true;
    },
    setSuccessFullySentRequestForSupportingDocumentsTouser: (state, action) => {
      state.successFullySentRequestForSupportingDocumentsTouser = true;
    },
    seEditUserDataRoutedSuccessFully: (state, action) => {
      state.editUserDataRoutedSuccessFully = true;
    },
    resetSuccessFullySentTouser: (state, action) => {
      state.successFullySentTouser = false;
      state.successFullySentRequestForSupportingDocumentsTouser = false;
      state.editUserDataRoutedSuccessFully = false;
    },
    setLogoutUrl: (state, action) => {
      state.clientLoagoutUrl = action.payload;
    },
    setActiveNavTab: (state, action) => {
      state.activeNavTab = action.payload;
    },
    clearToastContainer: (state) => {
      state.toastContainer = {};
    }, setworkFlowInfoLoading: (state, action) => {
      state.workFlowInfoLoading = action.payload
    },
    ResetDashboardDetailConfiguration: (state) => {
      state.dashboardDetailConfiguration = {};
    },
    setDataMatchAggregate: (state, action) => {
      state.dataMatchAggregate = action.payload;
    },
    setActionSuccess: (state, action) => {
      state.actionSuccess = action.payload;
    },
    setCheckingForApprovalButtonConstraint: (state, action) => {
      state.checkingForApprovalButtonConstraint = action.payload;
    },
    setShouldShowActionButtonsForApproval: (state, action) => {
      state.shouldShowActionButtonsForApproval = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(postRequestedDocs.pending, (state, action) => {
        state.postRequestedDocsloading = true;
      })
      .addCase(postRequestedDocs.fulfilled, (state, action) => {
        state.postRequestedDocsloading = false;
        if (action?.meta?.arg?.body?.requestedFlow === "edit") {
          state.editUserDataRoutedSuccessFully = true;
          state.successFullySentTouser = false;
        } else {
          state.editUserDataRoutedSuccessFully = false;
          state.successFullySentTouser = true;
        }
      })
      .addCase(postRequestedDocs.rejected, (state, action) => {
        state.postRequestedDocsloading = false;
      })

      builder
        .addCase(requestChangeForPaymentThroughId.pending, (state, action) => {
          state.postRequestedDocsloading = true;
        })
        .addCase(
          requestChangeForPaymentThroughId.fulfilled,
          (state, action) => {
            state.postRequestedDocsloading = false;
            if (action?.meta?.arg?.requestedFlow === "update") {
              state.editUserDataRoutedSuccessFully = false;
              state.successFullySentTouser = true;
            }
          }
        )
        .addCase(requestChangeForPaymentThroughId.rejected, (state, action) => {
          state.postRequestedDocsloading = false;
        });

      
    builder
      .addCase(fetchWorkflowInfoById.pending, (state, action) => {
        state.workFlowInfoLoading = true;
      })
      .addCase(fetchWorkflowInfoById.fulfilled, (state, action) => {
        if (!action.payload?.source_data?.subworkflows?.length) {
          state.noDataFoundForTheGivenId = true;
          state.workFlowInfoLoading = false;
          return;
        }

        state.workFlowInfoLoading = false;
        state.workFlowInfo = action.payload;
        state.fetchedWorkflow = true;
        state.currentSubWorkFlowId =
          action.payload?.source_data?.subworkflows?.[0]?._id;

        const usersObjectList = action?.payload?.source_data?.subworkflows?.reduce(
          (acc, subWorkFlow) => {
            acc[subWorkFlow._id] = {
              ...subWorkFlow,
            };
            return acc;
          },
          {}
        );
        state.usersList = usersObjectList;
      })
      .addCase(fetchWorkflowInfoById.rejected, (state, action) => {
        state.workFlowInfoLoading = false;
      });
    builder
      .addCase(fetchSubWorkflowInfoById.pending, (state, action) => {
        state.userSubworkFlowInfoLoading = true;
        state.userSubworkFlowInfo = {};
        state.dashboardDetailData = {};
      })
      .addCase(fetchSubWorkflowInfoById.fulfilled, (state, action) => {
        state.userSubworkFlowInfoLoading = false;
        // if(action.payload?.link)
        state.userSubworkFlowInfo = action?.payload;
      })
      .addCase(fetchSubWorkflowInfoById.rejected, (state, action) => {
        state.userSubworkFlowInfoLoading = false;
      });
    builder
      .addCase(createSupportingDocumentsConfig.pending, (state, action) => {
        // state.loading = true; // update the value once you get backend code ready
      })
      .addCase(createSupportingDocumentsConfig.fulfilled, (state, action) => {
        state.successFullySentRequestForSupportingDocumentsTouser = true;
      })
      .addCase(createSupportingDocumentsConfig.rejected, (state, action) => {
        // state.loading = false; // update the value once you get backend code ready
      })
    builder
      .addCase(updateDataAndStatusById.pending, (state) => {
        state.workFlowInfoLoading = true;
      })
      .addCase(updateDataAndStatusById.fulfilled, (state, action) => {
        if (action?.payload) {
          const { updateInfo } = action?.payload;

          if (updateInfo?.primary_workflow_id) {
            state.userSubworkFlowInfo = updateInfo;
          }
          if (updateInfo?.status === "Rejected") {
            let toastObj = {};
            toastObj = {
              show: true,
              message: "Applicant Rejected successfully",
              type: "success",
              autoClose: 3000,
            };
            state.toastContainer = toastObj;
          }
        }
        state.workFlowInfoLoading = false;
      })
      .addCase(updateDataAndStatusById.rejected, (state) => {
        state.workFlowInfoLoading = false;
      });
    builder
      .addCase(fetchDashboardDetailConfiguration.pending, (state, action) => {
        state.fetchingDashboardDetailConfiguration = true;
      })
      .addCase(fetchDashboardDetailConfiguration.fulfilled, (state, action) => {
        state.fetchingDashboardDetailConfiguration = false;
        state.dashboardDetailConfiguration = action.payload;
        state.sideBarStructure = action.payload?.configurationInfo?.sidebar_structure
      })
      .addCase(fetchDashboardDetailConfiguration.rejected, (state, action) => {
        state.fetchingDashboardDetailConfiguration = false;
      })
    builder
      .addCase(fechVKYCDataByPrimaryWorkflowId.pending, (state, action) => {
        state.vkyCResponseLoading = true;
      })
      .addCase(fechVKYCDataByPrimaryWorkflowId.fulfilled, (state, action) => {
        state.doesAnySubWorkflowHasVkyc = action.payload?.some(
          (item) => item?.vkyc_response
        );
        const vkycData = action.payload;
        vkycData &&
          vkycData.forEach((item) => {
            if (item?.vcip_response) {
              state.vkyCQueue = state.vkyCQueue.filter(
                (vkycItem) =>
                  vkycItem?.vcip_response?.id !== item?.vcip_response?.id
              );
              let vcipResponse = item?.vcip_response;
              vcipResponse = {
                ...vcipResponse,
                ...state.usersList?.[item?._id],
              };
              state.vkyCQueue.push(vcipResponse);
            }
            if (item?.vcip_callback) {
              state.vkycResponseOfAllSubWorkFlows =
                state.vkycResponseOfAllSubWorkFlows.filter(
                  (vkycItem) =>
                    vkycItem?.vcip_callback?.id !== item?.vcip_callback?.id
                );
              let vcipCallback = item?.vcip_callback;
              vcipCallback = {
                ...vcipCallback,
                ...state.usersList?.[item?._id],
              };
              state.vkycResponseOfAllSubWorkFlows.push(vcipCallback);
            }
          });
      })
      .addCase(fechVKYCDataByPrimaryWorkflowId.rejected, (state, action) => {
        state.vkyCResponseLoading = false;
      });
    builder
      .addCase(welcomeLetter.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(welcomeLetter.fulfilled, (state, action) => {
        state.welcomeLetterHtmlContent = action.payload;
      })
      .addCase(welcomeLetter.rejected, (state, action) => {
        state.error = "rejected";
        state.loading = false;
      })
    builder
      .addCase(linkCrnToWorkflow.pending, (state) => {
        state.workFlowInfoLoading = true;
      })
      .addCase(linkCrnToWorkflow.rejected, (state) => {
        state.workFlowInfoLoading = false;
      })
      .addCase(linkCrnToWorkflow.fulfilled, (state, action) => {
        const { status, message, data } = action.payload;
        let toastObj = {};
        if (status === "failed") {
          toastObj = {
            show: true,
            message,
            type: "error",
            autoClose: 3000,
          };
          state.toastContainer = toastObj;
        } else if (status === "success") {
          toastObj = {
            show: true,
            message,
            type: "success",
            autoClose: 3000,
          };
          state.toastContainer = toastObj;
          if (data?._id) {
            state.workFlowInfo = data;
            const usersObjectList = data?.source_data?.subworkflows?.reduce(
              (acc, subWorkFlow) => {
                acc[subWorkFlow._id] = {
                  ...subWorkFlow,
                };
                return acc;
              },
              {}
            );
            state.usersList = usersObjectList;
          }
        }
        state.workFlowInfoLoading = false;
      });
    builder
      .addCase(sendreminderAboutStatus.pending, (state) => {
        state.sentReminderAboutStatus = false;
      })
      .addCase(sendreminderAboutStatus.fulfilled, (state, action) => {
        state.sentReminderAboutStatus = true;
      })
      .addCase(sendreminderAboutStatus.rejected, (state, action) => {
        state.sentReminderAboutStatus = false;
      });
      builder
            .addCase(getUserNamesByIds.pending, (state, action) => {
              state.loading = true;
              state.error = null;
            })
            .addCase(getUserNamesByIds.fulfilled, (state, action) => {
              state.loading = false;
              state.userNamesInfo = action.payload;
            })
            .addCase(getUserNamesByIds.rejected, (state, action) => {
              state.loading = false;
              state.error = action.error.message;
            });
  },
});

export const {
  setRequestedDocs,
  setuserSubworkFlowInfo,
  setworkFlowInfo,
  clearworkFlowInfo,
  clearuserSubworkFlowInfo,
  setCurrentSubworkFlowId,
  setusersList,
  clearusersList,
  setDashBoardDetailData,
  ResetDashBoardDetailData,
  setSuccessFullySentTouser,
  resetSuccessFullySentTouser,
  setSuccessFullySentRequestForSupportingDocumentsTouser,
  seEditUserDataRoutedSuccessFully,
  setLogoutUrl,
  setActiveNavTab,
  clearToastContainer,
  setworkFlowInfoLoading,
  ResetCurrentSubworkFlowId,
  ResetDashboardDetailConfiguration,
  setDataMatchAggregate,
  setSubworkFlowInfo,
  setActionSuccess,
  setCheckingForApprovalButtonConstraint,
  setShouldShowActionButtonsForApproval
} = requestedDocsReducer.actions;

export default requestedDocsReducer.reducer;
